export default __webpack_public_path__ + "static/media/Unibank-heart-fill.c0fe90d1.svg";